import axios from "axios"
import { API_BASE_URL } from "../config"

export const manageCatvCreate = async (
  name: string,
  address: string,
  phone: string,
  sensitivity_enabled: number,
  sensitivity: number,
  detection_enabled: number,
  detection_period_start: string,
  detection_period_end: string,
  option_enabled: number,
  option_period_start: string,
  option_period_end: string,
  critical_count_enabled: number,
  critical_count: number
) => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/catv/create`, {
        session_code: localStorage.getItem("session_code"),
        name: name,
        address: address,
        phone: phone,
        sensitivity_enabled: sensitivity_enabled,
        sensitivity: sensitivity,
        detection_enabled: detection_enabled,
        detection_period_start: detection_period_start,
        detection_period_end: detection_period_end,
        option_enabled: option_enabled,
        option_period_start: option_period_start,
        option_period_end: option_period_end,
        critical_count_enabled: critical_count_enabled,
        critical_count: critical_count
      })

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }
      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
